// 寻找数组中出现次数最多的元素
export function findMost(arr: any[]) {
  const map = new Map();
  arr.forEach(d => {
    if (map.has(d)) {
      map.set(d, map.get(d) + 1);
    } else {
      map.set(d, 1);
    }
  });
  let max = -Infinity;
  let maxKey;
  map.forEach((value, key) => {
    if (value > max) {
      max = value;
      maxKey = key;
    }
  });
  return maxKey;
}
